import { Box, styled } from "@mui/material";

export const educatorProfilesStyle = (edit, dashboard) => ({
    root: {
        minHeight: '100vh',
        pt: { lg: edit ? 8 : 0, md: 6, sm: 3, xs: 2 }
    },
    mainGridBox: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "flex-start"
    },
    subGrid1Box: {
        mb: 6,
        display: { lg: "flex" },
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        p: { lg: 5, md: 5, sm: 5, xs: dashboard ? 0 : 2 },
    },
    subGrid1MainBox: { width: "100%", display: "flex", flexDirection: "column" },
    educatorText: { pb: 2 },
    aboutMeBox: {
        pb: 2,
        pt: 5,
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between'
    },
    subGrid2Box: {
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        p: { lg: 5, md: 5, sm: 5, xs: 5 }
    },
    subGrid2MainBox: {
        maxWidth: { md: "70%", lg: "100%", xlg: "100%" },
    },
    imageBox: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative"
    }
})
export const BioData = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(5),
    textAlign: "justify"
}))
export const SocialMediaContainer = styled(Box)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
}))
export const SocialMedia = styled('div')(({ theme }) => ({
    height: "50px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid black",
    cursor: "pointer",
    borderRadius: "30px",
    transition: "background 0.2s",
    "&:hover": {
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        borderColor: theme.palette.primary.main,
    }
}))
export const LinkTag = styled('a')(({ theme }) => ({
    height: "50px",
    width: "100%",
    display: "flex",
    textDecoration: "none",
    alignItems: "center",
    justifyContent: "center",
    color: "black",
    cursor: "pointer",
}))
export const SocialMediaText = styled('h6')(({ theme }) => ({
    textAlign: "center",
    fontWeight: "bold",
    paddingLeft: theme.spacing(1),
    margin: theme.spacing(0)
}))
